import { CATEGORY_ICON_SRC } from "./categoryIcons";

/**
 * Trivia Bazaar bonus-lane offers. Pack IDs match legacy API `recipeKey` fields.
 * Thumbnails reuse wheel category badges (`public/ui/category/*.webp`).
 */
export const BAZAAR_PACK_KEYS = [
  "salmon_bowl",
  "steak_and_eggs",
  "chicken_curry",
  "paella",
  "stuffed_peppers",
  "shrimp_pasta",
] as const;

export type BazaarPackKey = (typeof BAZAAR_PACK_KEYS)[number];

export const BAZAAR_PACK_META: Record<
  BazaarPackKey,
  { label: string; emoji: string; pitch: string; priceCoins: number; iconSrc: string }
> = {
  salmon_bowl: {
    label: "Coastal Trivia",
    emoji: "🌊",
    pitch: "Coastlines, oceans, and shore-to-sea geography lanes.",
    priceCoins: 595,
    iconSrc: CATEGORY_ICON_SRC.geography,
  },
  steak_and_eggs: {
    label: "Prime Time Plays",
    emoji: "🏆",
    pitch: "Sports moments & locker-room history mashups.",
    priceCoins: 770,
    iconSrc: CATEGORY_ICON_SRC.sports,
  },
  chicken_curry: {
    label: "Lab Sprint Science",
    emoji: "🧪",
    pitch: "Extra physics & biology prompts—sharp twists, zero filler.",
    priceCoins: 840,
    iconSrc: CATEGORY_ICON_SRC.science,
  },
  paella: {
    label: "Golden Age Cinema",
    emoji: "🎬",
    pitch: "Classic film, stage lore, and marquee legends.",
    priceCoins: 910,
    iconSrc: CATEGORY_ICON_SRC.entertainment,
  },
  stuffed_peppers: {
    label: "Curator's Circuit",
    emoji: "🎨",
    pitch: "Art movements & museum-worthy stumpers.",
    priceCoins: 980,
    iconSrc: CATEGORY_ICON_SRC.art,
  },
  shrimp_pasta: {
    label: "Marquee Deep Cuts",
    emoji: "🎭",
    pitch: "Entertainment deep cuts — stage, screen, streams.",
    priceCoins: 1120,
    iconSrc: CATEGORY_ICON_SRC.history,
  },
};
